function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M3.486 6.994l3.36 3.374-1.244 1.25L0 5.994 5.602.37l1.244 1.25-3.36 3.374H13v2z",
  fill: "#0B0E13",
  fillRule: "evenodd"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12"
  }, props), _ref);
};

export default "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMTNweCIgaGVpZ2h0PSIxMnB4IiB2aWV3Qm94PSIwIDAgMTMgMTIiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8IS0tIEdlbmVyYXRvcjogU2tldGNoIDQ5LjMgKDUxMTY3KSAtIGh0dHA6Ly93d3cuYm9oZW1pYW5jb2RpbmcuY29tL3NrZXRjaCAtLT4KICAgIDx0aXRsZT5hcnJvdy1sZWZ0PC90aXRsZT4KICAgIDxkZXNjPkNyZWF0ZWQgd2l0aCBTa2V0Y2guPC9kZXNjPgogICAgPGRlZnM+PC9kZWZzPgogICAgPGcgaWQ9IlN5bWJvbHMiIHN0cm9rZT0ibm9uZSIgc3Ryb2tlLXdpZHRoPSIxIiBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPgogICAgICAgIDxnIGlkPSJJY29ucy9BcnJvdy9MZWZ0IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMS4wMDAwMDAsIC0yLjAwMDAwMCkiIGZpbGw9IiMwQjBFMTMiPgogICAgICAgICAgICA8ZyBpZD0iYXJyb3ctbGVmdCI+CiAgICAgICAgICAgICAgICA8cG9seWdvbiBpZD0iQXJyb3ciIHBvaW50cz0iNC40ODU1Njg0OSA4Ljk5NDAwNjM4IDcuODQ2MzA2ODUgMTIuMzY4MjMzNyA2LjYwMTUyMzc4IDEzLjYxODAxMjkgMSA3Ljk5NDAwNjM4IDYuNjAxNTIzNzggMi4zNjk5OTk4OSA3Ljg0NjMwNjg1IDMuNjE5Nzc5MTEgNC40ODU1Njg0OSA2Ljk5NDAwNjM4IDE0IDYuOTk0MDA2MzggMTQgOC45OTQwMDYzOCI+PC9wb2x5Z29uPgogICAgICAgICAgICA8L2c+CiAgICAgICAgPC9nPgogICAgPC9nPgo8L3N2Zz4=";
export { SvgComponent as ReactComponent };


// WEBPACK FOOTER //
// ./src/images/icons/arrow-left.svg